import React from "react";
import './usecase-title.css'

// ...... images ........
import marketing from '../../../../assets/images/marketing.svg';


function UsecaseTitle() {
   return(
       <div className="marketing relative">
          <div className="content-box padd width-1000 relative">
             <div className="marketing-label margin-b-20">Support</div>
             <div className="marketing-title rubik-medium">
                Say goodbye to repeat questions and hello to faster resolution
             </div>
          </div>
       </div>
   )
}

export default UsecaseTitle
